/** The connection frame's chrome. */
export default {
  noConnections: "No integrations connected yet",
  connectHint:
    "Open Settings → Connections to connect Gmail, GitHub, and more.",
  appsConnected: {
    one: "{count} app connected",
    other: "{count} apps connected",
  },
} as const;
